import React, { Suspense } from 'react';
import { Loader } from '$shared/components';

export const DynamicComponent: React.FC = ({ children }) => {
  return <Suspense fallback={<Loader isWrapped />}>{children}</Suspense>;
};
